import React, {Component} from 'react';
import moment from 'moment';
import PageVisibility from 'react-page-visibility';
import {Link, withRouter} from 'react-router-dom';
import {observer} from 'mobx-react'
import {Desktop, MobileTablet} from "./Responsive";

@observer
class TopMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.getLastUpdated = this.getLastUpdated.bind(this);
    }

    getLastUpdated() {
        if (this.props.appState.updated) {
            let updateTime = moment(this.props.appState.updated);
            return (
                <div className="cg-last-update-text">
                    Last updated {updateTime.format("HH:mm")}, {updateTime.fromNow()}
                </div>
            );
        }

        return null;
    }

    render() {
        return (
            <div className="cg-top-header-container">
                <div className="cg-menu box-shadow">
                    <Link className="cg-menu-item" to="/">
                        <span className="cg-icon-container">
                            <img className="cg-menu-coingrasp" src="/images/coingrasp-logo.svg"
                                 alt="CoinGrasp logo"/>
                        </span>
                        <span className="cg-menu-text">Coins</span>
                    </Link>

                    <MobileTablet>
                        <Link className="cg-menu-item" to="/toplists">
                            <span className="cg-icon-container">
                                <i className="fal fa-money-bill-alt"/>
                            </span>
                            <span className="cg-menu-text">Top lists</span>
                        </Link>
                    </MobileTablet>

                    <Link className="cg-menu-item" to="/about">
                        <span className="cg-icon-container">
                            <i className="fal fa-info-square"/>
                        </span>
                        <span className="cg-menu-text">About</span>
                    </Link>

                    <Link className="cg-menu-item" to="/settings">
                        <span className="cg-icon-container">
                            <i className="fal fa-cog"/>
                        </span>
                        <span className="cg-menu-text">Settings</span>
                    </Link>
                </div>

                <Desktop>
                    <div className="cg-last-update">
                        <PageVisibility onChange={this.props.handleVisibilityChange}>
                            {this.getLastUpdated()}
                        </PageVisibility>
                    </div>
                </Desktop>
            </div>
        );
    }
}

export default withRouter(TopMenu);



// WEBPACK FOOTER //
// ./src/TopMenu.js